import cleareLocalStorage from './cleareLocalStorage';

export const FORCE_LOGOUT_MESSAGE_SESSION_KEY = 'loginSessionExpired';

let isLoggingOut = false;

const forceSessionLogout = (): void => {
    if (isLoggingOut) {
        return;
    }

    isLoggingOut = true;
    sessionStorage.setItem(FORCE_LOGOUT_MESSAGE_SESSION_KEY, '1');
    cleareLocalStorage();
    window.location.reload();
};

export default forceSessionLogout;
